// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__+Vl4z","wrapperIcon":"Button_wrapperIcon__lyOtB","icon":"Button_icon__sqcxB"};